export default __webpack_public_path__ + "static/media/c-javascript.a642e45c.jpg";